import React from 'react'
const Spinner = (props) => props.spin ? <div className={props.className} style={props.style}><i className="fa fa-refresh fa-spin fa-fw"></i>Se incarca...</div> : null
export default Spinner
